import {
  AratData,
  Assessment,
  AssessmentSubType,
  AssessmentType,
  BbsData,
  BbsDataSet,
  BbtData,
  FgaData,
  FgaDataSet,
  FrData,
  IcfCategory,
  Mwt6Data,
  NhptData,
  ReportDetailItem,
  ReportItem,
  ReportItemNote,
  SingleNumberDataSet,
  SubTestDataSet,
  TsData,
  TsDataSet,
  TugData,
  TwoHandsNumberDataSet,
} from './model';

export function generateReport(assessments: Assessment[], reportNotes: ReportItemNote[]) {
  const reportItems: { [key in IcfCategory]?: ReportItem } = {
    // b760: {
    //   icfCategory: 'b760',
    //   score: undefined,
    //   note: undefined,
    //   details: [],
    // },
    // d430: {
  };
  const doneTypes: Set<AssessmentType> = new Set();

  assessments.forEach(assessment => {
    const firstOfType: boolean = !doneTypes.has(assessment.type);
    firstOfType && doneTypes.add(assessment.type);

    if (assessment.type === 'ARAT') {
      const data: AratData = assessment.data as AratData;
      const keys = Object.keys(data) as Array<keyof AratData>;

      keys.forEach(subType => {
        const subTest: SubTestDataSet<TwoHandsNumberDataSet> = data[subType];
        subTest.icfCategory?.forEach((catName: IcfCategory) => {
          const itemDetail: ReportDetailItem = getReportDetailItemNew(
            subTest,
            assessment.type,
            assessment.dateIso,
            subType
          );
          addOrUpdateReportItemNew(catName, assessment, subTest, itemDetail, reportItems, firstOfType);
        });
      });
    } else if (assessment.type === 'BBT') {
      const data: BbtData = assessment.data as BbtData;
      const keys = Object.keys(data) as Array<keyof BbtData>;

      keys.forEach(subType => {
        const subTest: SubTestDataSet<TwoHandsNumberDataSet> = data[subType];
        subTest.icfCategory.forEach((catName: IcfCategory) => {
          const itemDetail: ReportDetailItem = getReportDetailItem(
            subTest,
            assessment.type,
            assessment.dateIso,
            subType
          );
          addOrUpdateReportItem(catName, assessment, subTest, itemDetail, reportItems, firstOfType);
        });
      });
    } else if (assessment.type === 'TS') {
      const data: TsData = assessment.data as TsData;
      const keys = Object.keys(data) as Array<keyof TsData>;

      keys.forEach(subType => {
        const subTest: SubTestDataSet<TsDataSet> = data[subType];
        subTest.icfCategory.forEach((catName: IcfCategory) => {
          const itemDetail: ReportDetailItem = getReportDetailItemTS(
            subTest,
            assessment.type,
            assessment.dateIso,
            subType
          );
          addOrUpdateReportItemTS(catName, assessment, subTest, itemDetail, reportItems, firstOfType);
        });
      });
    } else if (assessment.type === 'TUG') {
      const data: TugData = assessment.data as TugData;
      const keys = Object.keys(data) as Array<keyof TugData>;

      keys.forEach(subType => {
        const subTest: SubTestDataSet<SingleNumberDataSet> = data[subType];
        subTest.icfCategory.forEach((catName: IcfCategory) => {
          const itemDetail: ReportDetailItem = getReportDetailItemSingleNumber(
            subTest,
            assessment.type,
            assessment.dateIso,
            subType
          );
          addOrUpdateReportItemSingleNumber(catName, assessment, subTest, itemDetail, reportItems, firstOfType);
        });
      });
    } else if (assessment.type === 'FR') {
      const data: FrData = assessment.data as FrData;
      const keys = Object.keys(data) as Array<keyof FrData>;

      keys.forEach(subType => {
        const subTest: SubTestDataSet<SingleNumberDataSet> = data[subType];
        subTest.icfCategory.forEach((catName: IcfCategory) => {
          const itemDetail: ReportDetailItem = getReportDetailItemSingleNumber(
            subTest,
            assessment.type,
            assessment.dateIso,
            subType
          );
          addOrUpdateReportItemSingleNumber(catName, assessment, subTest, itemDetail, reportItems, firstOfType);
        });
      });
    } else if (assessment.type === 'MWT6') {
      const data: Mwt6Data = assessment.data as Mwt6Data;
      const keys = Object.keys(data) as Array<keyof Mwt6Data>;

      keys.forEach(subType => {
        const subTest: SubTestDataSet<SingleNumberDataSet> = data[subType];
        subTest.icfCategory.forEach((catName: IcfCategory) => {
          const itemDetail: ReportDetailItem = getReportDetailItemSingleNumber(
            subTest,
            assessment.type,
            assessment.dateIso,
            subType
          );
          addOrUpdateReportItemSingleNumber(catName, assessment, subTest, itemDetail, reportItems, firstOfType);
        });
      });
    } else if (assessment.type === 'BBS') {
      const data: BbsData = assessment.data as BbsData;
      const keys = Object.keys(data) as Array<keyof BbsData>;

      keys.forEach(subType => {
        const subTest: SubTestDataSet<BbsDataSet> = data[subType];
        subTest.data.forEach(thDataSet => {
          thDataSet.icfCategory.forEach((catName: IcfCategory) => {
            const itemDetail: ReportDetailItem = getReportDetailItemBBS(
              thDataSet,
              assessment.type,
              assessment.dateIso,
              subType,
              subTest.note
            );
            addOrUpdateReportItemBBS(catName, assessment, subTest, thDataSet, itemDetail, reportItems, firstOfType);
          });
        });
      });
    } else if (assessment.type === 'FGA') {
      const data: FgaData = assessment.data as FgaData;
      const keys = Object.keys(data) as Array<keyof FgaData>;

      keys.forEach(subType => {
        const subTest: SubTestDataSet<FgaDataSet> = data[subType];
        subTest.data.forEach(thDataSet => {
          thDataSet.icfCategory.forEach((catName: IcfCategory) => {
            const itemDetail: ReportDetailItem = getReportDetailItemBBS(
              thDataSet,
              assessment.type,
              assessment.dateIso,
              subType,
              subTest.note
            );
            addOrUpdateReportItemBBS(catName, assessment, subTest, thDataSet, itemDetail, reportItems, firstOfType);
          });
        });
      });
    } else if (assessment.type === 'NHPT') {
      const data: NhptData = assessment.data as NhptData;
      const keys = Object.keys(data) as Array<keyof NhptData>;

      keys.forEach(subType => {
        const subTest: SubTestDataSet<TwoHandsNumberDataSet> = data[subType];
        subTest.icfCategory.forEach((catName: IcfCategory) => {
          const itemDetail: ReportDetailItem = getReportDetailItem(
            subTest,
            assessment.type,
            assessment.dateIso,
            subType
          );
          addOrUpdateReportItem(catName, assessment, subTest, itemDetail, reportItems, firstOfType);
        });
      });
    }
  });
  console.log('reportItems', reportItems);
  Object.values(reportItems).forEach(reportItem => {
    let sum = 0;
    let count = 0;
    reportItem.details.sort((a, b) => (a.type + a.subType).localeCompare(b.type + b.subType));
    reportItem.details.forEach(detail => {
      if (detail.scorePercent != null) {
        sum += detail.scorePercent;
        count++;
      }
    });
    if (count > 0) {
      reportItem.scoreAverage = Math.round(sum / count);
    } else {
      reportItem.scoreAverage = 0;
    }
    const reportNoteDetails = reportNotes.find(note => note.icfCategory === reportItem.icfCategory);
    reportItem.customNote = reportNoteDetails?.note ?? '';
    reportItem.icfScoreSelected = reportNoteDetails?.icfScoreSelected ?? -1;
  });

  console.log('[reportItems] with notes', reportItems);
  return reportItems;
}

function getReportDetailItem(
  subTest: SubTestDataSet<TwoHandsNumberDataSet>,
  type: AssessmentType,
  dateIso: string,
  subType: AssessmentSubType
): ReportDetailItem {
  const itemDetail: ReportDetailItem = {
    type,
    subType,
    dateIso,
    scorePercent: getScoreOr8(subTest.score),
    score_left: getScoreOr8(subTest.score_left),
    scoreLeftHistory: [getScoreOr8(subTest.score_left)],
    score_right: getScoreOr8(subTest.score_right),
    scoreRightHistory: [getScoreOr8(subTest.score_right)],
    note: subTest.note,
  };
  itemDetail.history = [getHistoryData(itemDetail)];
  return itemDetail;
}

function getReportDetailItemNew(
  subTest: SubTestDataSet<TwoHandsNumberDataSet>,
  type: AssessmentType,
  dateIso: string,
  subType: AssessmentSubType
): ReportDetailItem {
  const itemDetail: ReportDetailItem = {
    type,
    subType,
    dateIso,
    scorePercent: getScoreOr8(subTest.scorePercentage),
    score_left: getScoreOr8(subTest.scoreLeftPercentage),
    scoreLeftHistory: [getScoreOr8(subTest.scoreLeftPercentage)],
    score_right: getScoreOr8(subTest.scoreRightPercentage),
    scoreRightHistory: [getScoreOr8(subTest.scoreRightPercentage)],
    note: subTest.note,
  };
  itemDetail.history = [getHistoryData(itemDetail)];
  return itemDetail;
}

function getReportDetailItemTS(
  subTest: SubTestDataSet<TsDataSet>,
  type: AssessmentType,
  dateIso: string,
  subType: AssessmentSubType
): ReportDetailItem {
  const itemDetail: ReportDetailItem = {
    type,
    subType,
    dateIso,
    scorePercent: getScoreOr8(subTest.score),
    score_left: getScoreOr8(subTest.score_left),
    scoreLeftHistory: [getScoreOr8(subTest.score_left)],
    score_right: getScoreOr8(subTest.score_right),
    scoreRightHistory: [getScoreOr8(subTest.score_right)],
    note: subTest.note,
  };
  itemDetail.history = [getHistoryData(itemDetail)];
  return itemDetail;
}

function getReportDetailItemSingleNumber(
  subTest: SubTestDataSet<SingleNumberDataSet>,
  type: AssessmentType,
  dateIso: string,
  subType: AssessmentSubType
): ReportDetailItem {
  const itemDetail: ReportDetailItem = {
    type,
    subType,
    dateIso,
    scorePercent: getScoreOr8(subTest.score),
    score_left: getScoreOr8(subTest.score),
    scoreLeftHistory: [getScoreOr8(subTest.score)],
    score_right: getScoreOr8(subTest.score),
    scoreRightHistory: [getScoreOr8(subTest.score)],
    note: subTest.note,
  };
  itemDetail.history = [getHistoryData(itemDetail)];
  return itemDetail;
}

function getReportDetailItemBBS(
  thDataSet: BbsDataSet,
  type: AssessmentType,
  dateIso: string,
  subType: AssessmentSubType,
  note: string
): ReportDetailItem {
  const itemDetail: ReportDetailItem = {
    type,
    subType,
    dateIso,
    scorePercent: getScoreOr8(thDataSet.score),
    score_left: getScoreOr8(thDataSet.score),
    scoreLeftHistory: [getScoreOr8(thDataSet.score)],
    score_right: getScoreOr8(thDataSet.score),
    scoreRightHistory: [getScoreOr8(thDataSet.score)],
    note,
  };
  itemDetail.history = [getHistoryData(itemDetail)];
  return itemDetail;
}

function addOrUpdateReportItem(
  catName: IcfCategory,
  assessment: Assessment,
  subTest: SubTestDataSet<TwoHandsNumberDataSet>,
  itemDetail: ReportDetailItem,
  reportItems: { [key in IcfCategory]?: ReportItem },
  firstOfType: boolean
) {
  // if (catName === 'd440') {
  //   console.log('bbt');
  // }

  let item: ReportItem;
  if (reportItems[catName] === undefined) {
    reportItems[catName] = {
      icfCategory: catName,
      score: 0,
      note: '',
      customNote: '',
      details: [itemDetail],
      assessmentTypes: [assessment.type],
    };
    item = reportItems[catName]!;
  } else {
    item = reportItems[catName]!;

    addDetail(itemDetail, item.details);

    if (!item.assessmentTypes.some(t => t === assessment.type)) {
      item.assessmentTypes.push(assessment.type);
    }
  }
  if (firstOfType) {
    const subtestScore = getScoreOr8(subTest.score);
    // item.score = subtestScore > item.score! ? subtestScore : item.score; // schlechtester Wert soll genannt werden, nicht der durchschnitt!
    item.score = subtestScore;
    item.note = getNote(subTest.note, assessment, item, itemDetail.subType);
  }
}

function addOrUpdateReportItemNew(
  catName: IcfCategory,
  assessment: Assessment,
  subTest: SubTestDataSet<TwoHandsNumberDataSet>,
  itemDetail: ReportDetailItem,
  reportItems: { [key in IcfCategory]?: ReportItem },
  firstOfType: boolean
) {
  // if (catName === 'd440') {
  //   console.log('bbt');
  // }

  let item: ReportItem;
  if (reportItems[catName] === undefined) {
    reportItems[catName] = {
      icfCategory: catName,
      score: 0,
      note: '',
      customNote: '',
      details: [itemDetail],
      assessmentTypes: [assessment.type],
    };
    item = reportItems[catName]!;
  } else {
    item = reportItems[catName]!;

    addDetail(itemDetail, item.details);

    if (!item.assessmentTypes.some(t => t === assessment.type)) {
      item.assessmentTypes.push(assessment.type);
    }
  }
  if (firstOfType) {
    // const subtestScore = getScoreOr8(subTest.score);
    // item.score = subtestScore > item.score! ? subtestScore : item.score; // schlechtester Wert soll genannt werden, nicht der durchschnitt!
    // nur der arat hat hier einen score of oberster Ebene
    // item.score = getScoreOr8(assessment.scorePercentage);
    // console.log('item.score für ' + catName + ': ' + item.score, item, reportItems);

    item.note = getNote(subTest.note, assessment, item, itemDetail.subType);
  }
}

function addOrUpdateReportItemTS(
  catName: IcfCategory,
  assessment: Assessment,
  subTest: SubTestDataSet<TsDataSet>,
  itemDetail: ReportDetailItem,
  reportItems: { [key in IcfCategory]?: ReportItem },
  firstOfType: boolean
) {
  let item: ReportItem;
  if (reportItems[catName] === undefined) {
    reportItems[catName] = {
      icfCategory: catName,
      score: 0,
      note: '',
      customNote: '',
      details: [itemDetail],
      assessmentTypes: [assessment.type],
    };
    item = reportItems[catName]!;
  } else {
    item = reportItems[catName]!;

    addDetail(itemDetail, item.details);

    if (!item.assessmentTypes.some(t => t === assessment.type)) {
      item.assessmentTypes.push(assessment.type);
    }
  }
  if (firstOfType) {
    const subtestScore = getScoreOr8(subTest.score);
    // item.score = subtestScore > item.score! ? subtestScore : item.score; // schlechtester Wert soll genannt werden, nicht der durchschnitt!
    // item.score = subtestScore;
    item.note = getNote(subTest.note, assessment, item, itemDetail.subType);
  }
}

function addOrUpdateReportItemSingleNumber(
  catName: IcfCategory,
  assessment: Assessment,
  subTest: SubTestDataSet<SingleNumberDataSet>,
  itemDetail: ReportDetailItem,
  reportItems: { [key in IcfCategory]?: ReportItem },
  firstOfType: boolean
) {
  let item: ReportItem;
  if (reportItems[catName] === undefined) {
    reportItems[catName] = {
      icfCategory: catName,
      score: 0,
      note: '',
      customNote: '',
      details: [itemDetail],
      assessmentTypes: [assessment.type],
    };
    item = reportItems[catName]!;
  } else {
    item = reportItems[catName]!;

    addDetail(itemDetail, item.details);

    if (!item.assessmentTypes.some(t => t === assessment.type)) {
      item.assessmentTypes.push(assessment.type);
    }
  }
  if (firstOfType) {
    const subtestScore = getScoreOr8(subTest.score);
    // item.score = subtestScore > item.score! ? subtestScore : item.score; // schlechtester Wert soll genannt werden, nicht der durchschnitt!
    // item.score = subtestScore;
    item.note = getNote(subTest.note, assessment, item, itemDetail.subType);
  }
}

function addOrUpdateReportItemBBS(
  catName: IcfCategory,
  assessment: Assessment,
  subTest: SubTestDataSet<BbsDataSet>,
  thDataSet: BbsDataSet,
  itemDetail: ReportDetailItem,
  reportItems: { [key in IcfCategory]?: ReportItem },
  firstOfType: boolean
) {
  let item: ReportItem;
  if (reportItems[catName] === undefined) {
    reportItems[catName] = {
      icfCategory: catName,
      score: 0,
      note: '',
      customNote: '',
      details: [itemDetail],
      assessmentTypes: [assessment.type],
    };
    item = reportItems[catName]!;
  } else {
    item = reportItems[catName]!;

    addDetail(itemDetail, item.details);

    if (!item.assessmentTypes.some(t => t === assessment.type)) {
      item.assessmentTypes.push(assessment.type);
    }
  }

  if (firstOfType) {
    const subtestScore = getScoreOr8(thDataSet.score);
    // item.score = subtestScore > item.score! ? subtestScore : item.score; // schlechtester Wert soll genannt werden, nicht der durchschnitt!
    // item.score = subtestScore;
    item.note = getNote(subTest.note, assessment, item, itemDetail.subType);
  }
  // console.log('reportItemsbbs', reportItems);
}

function addDetail(newDetail: ReportDetailItem, details: ReportDetailItem[]) {
  const existingDetail = details.find(item => item.subType === newDetail.subType);
  if (existingDetail) {
    const existingTimesamp = new Date(existingDetail.dateIso).getTime();
    const newTimesamp = new Date(newDetail.dateIso).getTime();
    if (existingTimesamp > newTimesamp) {
      // new one is history Data
    } else {
      // new one is the most recent
      existingDetail.dateIso = newDetail.dateIso;
      existingDetail.score_left = newDetail.score_left;
      existingDetail.score_right = newDetail.score_right;
      existingDetail.note = newDetail.note;
    }
    existingDetail.history?.push(getHistoryData(newDetail));
  } else {
    newDetail.history = [getHistoryData(newDetail)];
    details.push(newDetail);
  }
}

function getHistoryData(newDetail: ReportDetailItem) {
  return {
    type: newDetail.type,
    subType: newDetail.subType,
    dateIso: newDetail.dateIso,
    score_left: newDetail.score_left,
    score_right: newDetail.score_right,
    note: newDetail.note,
  };
}

function getScoreOr8(score: number | null | undefined): number {
  if (score !== undefined && score !== null) {
    return Math.round(score * 100);
  } else {
    return 100;
  }
}

function getNote(note: string, assessment: Assessment, item: ReportItem, subType: AssessmentSubType): string {
  if (note.length > 0) {
    let result: string = '';
    if (item.note.length > 0) {
      // result = item.note + '\n';
      result = item.note + '||';
    }
    let type = assessment.type;
    if (type !== subType.toUpperCase()) {
      type += ' ' + subType;
    }
    // return result + type + ' ' + dayjs(assessment.dateIso).format('MM.DD.YYYY') + ': ' + note;
    return result + type + '::' + note;
  } else {
    return item.note;
  }
}
